module.exports = __webpack_public_path__ + "media/icons/cuk_mail-a7eaa1f3.png";